import { Header } from '@components/sources/source/warehouseSource/configureData/style';
import useStores from '@stores/useStores';
import _ from 'lodash';
import React from 'react';
import { useConnectionState } from '../../visualDataMappingProvider';
import classes from '../mappingConfig/mapping-commons.module.scss';
import SyncBehaviourSelect, { SyncBehaviourSelectOptionProps } from './syncBehaviourSelect';

export const syncBehaviourLabels: { [name: string]: string } = {
  upsert: 'Upsert',
  mirror: 'Mirror',
};

export const getSyncBehaviourOptions = (
  customerSyncBehaviours: string[],
  srcSyncBehaviours?: string[],
  destSyncBehaviours?: string[],
) => {
  const syncBehaviourOptions: SyncBehaviourSelectOptionProps[] = _.intersection(
    customerSyncBehaviours,
    _.intersection(srcSyncBehaviours, destSyncBehaviours || ['upsert']),
  ).map((mode: string) => ({ value: mode, label: syncBehaviourLabels[mode] }));
  return syncBehaviourOptions;
};

const SyncBehaviourConfig: React.FC = () => {
  const { workspaceStore } = useStores();
  const { source, destination, viewOnly, ifUpdate, syncBehaviour, setSyncBehaviour } =
    useConnectionState();
  const isViewOrUpdate = viewOnly || ifUpdate;
  const syncBehaviourOptions = getSyncBehaviourOptions(
    workspaceStore.whActionsSyncBehaviours,
    source.sourceDef?.options?.syncBehaviours,
    destination.destinationDefinition?.config?.syncBehaviours,
  );
  return (syncBehaviourOptions.length > 0 && !isViewOrUpdate) ||
    (syncBehaviour?.mode &&
      workspaceStore.whActionsSyncBehaviours.includes(syncBehaviour?.mode)) ? (
    <>
      <div className={classes.head_wrapper}>
        <Header>How are source and destination records matched?</Header>
      </div>

      <SyncBehaviourSelect
        syncBehaviourOptions={syncBehaviourOptions}
        isViewOrUpdate={isViewOrUpdate}
        currentMode={syncBehaviour?.mode}
        setSyncBehaviour={setSyncBehaviour}
      />
    </>
  ) : null;
};
export default SyncBehaviourConfig;
